/* eslint-disable no-redeclare */

import { z } from 'zod';

export const MemberType = z.enum(['PRIMARY', 'SPOUSE', 'CHILD']);
export type MemberType = z.infer<typeof MemberType>;
